import { OnInit, ChangeDetectorRef, ElementRef, QueryList, AfterViewInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subscription, forkJoin } from 'rxjs';
import { BsModalEventsEmitter } from 'src/app/modules/shared/events/bsModal.events';
import { DiaryService } from '../../../../shared/services/diary.service';
import { filter } from 'rxjs/operators';
import { ViewRecipeComponent } from '../view-recipe/view-recipe.component';
import { NouisliderComponent } from 'ng2-nouislider';
import { Constants } from '../../../../shared/config/constants.config';
import { AddRecipeFilterModalComponent } from '../add-recipe-filter/add-recipe-filter.component';
import { UpgradeComponent } from '../../../../shared/components/modals/upgrade/upgrade.component';
import { Router } from '@angular/router';
import { PricingService } from '../../../../pricing/services/pricing.service';
import { LocalisationService } from '../../../../shared/services/localisation.service';
var AddRecipeModalComponent = /** @class */ (function () {
    function AddRecipeModalComponent(bsModalRef, bsModalEventsEmitter, diaryService, bsModalService, changeDetectorRef, constants, router, pricingService, localisationService) {
        this.bsModalRef = bsModalRef;
        this.bsModalEventsEmitter = bsModalEventsEmitter;
        this.diaryService = diaryService;
        this.bsModalService = bsModalService;
        this.changeDetectorRef = changeDetectorRef;
        this.constants = constants;
        this.router = router;
        this.pricingService = pricingService;
        this.localisationService = localisationService;
        this.mobileWidth = 576;
        this.loading = true;
        this.hideSlider = true;
        this.searchText = '';
        this.selectedCategory = 1;
        this.subscriptions = [];
        this.left_calories = 0;
        this.current_left_calories = 0;
        this.percentage = 100;
        this.showSearch = false;
        this.selectedAttributeOptionIds = [];
        this.hasVideo = false;
        this.selectedGlobalCategories = [];
        this.mealPrepFriendly = null;
        this.isFreePlan = false;
    }
    AddRecipeModalComponent.prototype.ngOnInit = function () {
        var _this_1 = this;
        this.subscriptions.push(this.bsModalEventsEmitter.bsModalStateChanged$.pipe(filter(function (bsModalRef) { return bsModalRef === _this_1.bsModalRef; })).subscribe(function () {
            _this_1.left_calories = _this_1.mealsComponent.caloriesLeftByMeal[_this_1.meal.id];
            _this_1.current_left_calories = _this_1.left_calories;
            _this_1.recipes = null;
            _this_1.init();
        }));
    };
    AddRecipeModalComponent.prototype.ngAfterViewInit = function () {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    };
    AddRecipeModalComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    AddRecipeModalComponent.prototype.attributeOptionsChange = function (options) {
        this.selectedAttributeOptionIds = options;
    };
    AddRecipeModalComponent.prototype.leftCaloriesChanged = function (leftCalories) {
        this.current_left_calories = leftCalories;
    };
    AddRecipeModalComponent.prototype.onChangeCategory = function (category) {
        this.selectedCategory = category;
        this.initRecipes();
    };
    AddRecipeModalComponent.prototype.onViewRecipe = function (e, recipe, blockRecipeOpenAndOpenUpgradeModal) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (blockRecipeOpenAndOpenUpgradeModal === true) {
            this.openUpgradeModal();
            return;
        }
        this.viewRecipeBsModalRef = this.bsModalService.show(ViewRecipeComponent, {
            backdrop: true
        });
        this.viewRecipeBsModalRef.content.mealRecipe = recipe;
        this.viewRecipeBsModalRef.content.meal = this.meal;
        this.viewRecipeBsModalRef.content.mealsComponent = this.mealsComponent;
        this.viewRecipeBsModalRef.content.addRecipeModalRef = this.bsModalRef;
        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.viewRecipeBsModalRef);
    };
    AddRecipeModalComponent.prototype.openFilter = function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (this.isFreePlan) {
            this.openUpgradeModal();
        }
        else {
            this.viewRecipeBsModalRef = this.bsModalService.show(AddRecipeFilterModalComponent, {
                backdrop: true
            });
            this.viewRecipeBsModalRef.content.meal = this.meal;
            this.viewRecipeBsModalRef.content.mealsComponent = this.mealsComponent;
            this.viewRecipeBsModalRef.content.addRecipeComponent = this;
            this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.viewRecipeBsModalRef);
        }
    };
    AddRecipeModalComponent.prototype.filterRecipes = function (recipe, _this) {
        if (_this.searchText.length <= 0) {
            return true;
        }
        return recipe.recipe.title.toLowerCase().includes(_this.searchText.toLowerCase());
    };
    AddRecipeModalComponent.prototype.initRecipes = function (showSlider) {
        var _this_1 = this;
        if (showSlider === void 0) { showSlider = false; }
        this.loading = true;
        this.changeDetectorRef.detectChanges();
        var recipesDto = {
            date: this.mealsComponent.date,
            meal: this.meal.id,
            search_text: null,
            category: this.selectedCategory ? this.selectedCategory : undefined,
            left_calories: this.current_left_calories,
            attributes: (this.selectedAttributeOptionIds.length > 0 ? this.selectedAttributeOptionIds : null),
            meal_prep_friendly: this.mealPrepFriendly,
            has_video: this.hasVideo,
            selectedGlobalCategories: this.selectedGlobalCategories,
            lang: this.localisationService.getLanguage(),
            user_id: this.mealsComponent.userProfile.id
        };
        forkJoin(this.diaryService.getNewRecipes(recipesDto), this.diaryService.getRecipesCategories(this.meal), this.pricingService.isFreePlan()).subscribe(function (_a) {
            var recipes = _a[0], recipeCategories = _a[1], isFreePlan = _a[2];
            var newRecipes = [];
            recipes.forEach(function (recipe) {
                var newProducts = [];
                recipe['products'].forEach(function (product) {
                    newProducts.push({
                        'product_id': product['id'],
                        'qty': product['qty'],
                        'weight': product['weight'],
                    });
                });
                newRecipes.push({
                    macros: recipe['macros'],
                    products: newProducts,
                    recipe: {
                        'id': recipe['id'],
                        'title': recipe['title'],
                        'allergies': [],
                        'how_to_cook_text': null,
                        'youtube_link': recipe['youtube_link'],
                        'images': recipe['images'],
                        'price': recipe['price'],
                    }
                });
            });
            _this_1.recipes = newRecipes;
            _this_1.recipeCategories = recipeCategories;
            _this_1.isFreePlan = isFreePlan;
            _this_1.loading = false;
            if (showSlider === true) {
                _this_1.hideSlider = false;
            }
            _this_1.changeDetectorRef.markForCheck();
        }, function () {
            _this_1.loading = false;
        });
    };
    AddRecipeModalComponent.prototype.init = function () {
        this.changeDetectorRef.markForCheck();
        this.initRecipes(true);
    };
    AddRecipeModalComponent.prototype.toFullscreen = function () {
        var modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        var modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        var modal = this.wrapper.nativeElement.parentElement;
        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    };
    AddRecipeModalComponent.prototype.floor = function (number) {
        return Math.floor(number);
    };
    AddRecipeModalComponent.prototype.getSvg = function (svg) {
        // if (this.themeService.getCurrentTheme() !== 'light') {
        svg += '-white';
        // }
        return "assets/images/macros/" + svg + ".svg";
    };
    AddRecipeModalComponent.prototype.openUpgradeModal = function () {
        this.viewRecipeBsModalRef = this.bsModalService.show(UpgradeComponent, {
            backdrop: true
        });
        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.viewRecipeBsModalRef);
    };
    AddRecipeModalComponent.prototype.toPricing = function () {
        this.router.navigate(['pricing']);
        this.bsModalRef.hide();
    };
    AddRecipeModalComponent.prototype.toggleSearch = function () {
        var _this_1 = this;
        this.showSearch = !this.showSearch;
        if (this.showSearch === true) {
            this.searchElement.nativeElement.focus();
            setTimeout(function () {
                _this_1.searchElement.nativeElement.focus();
            }, 500);
        }
    };
    return AddRecipeModalComponent;
}());
export { AddRecipeModalComponent };
